import { render, staticRenderFns } from "./Advertisers.vue?vue&type=template&id=924a324c&scoped=true&"
import script from "./Advertisers.vue?vue&type=script&lang=js&"
export * from "./Advertisers.vue?vue&type=script&lang=js&"
import style0 from "./Advertisers.vue?vue&type=style&index=0&id=924a324c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924a324c",
  null
  
)

export default component.exports